@if (safeContent) {
  <div class="content" #blogSection [innerHTML]="safeContent"></div>
}
